import { FileButton, FileButtonProps } from '@mantine/core';
import { useRef } from 'react';

export function AutoResetFileButton(props: FileButtonProps) {
  const resetRef = useRef<() => void>(null);

  const handleChange = (file: File | null) => {
    props.onChange?.(file);
    resetRef.current?.();
  };

  return (
    <FileButton {...props} onChange={handleChange} resetRef={resetRef}>
      {props.children}
    </FileButton>
  );
}